import { azureCostConstants } from "../constants/azureCost.constants";

export function azureCost(state = {}, action) {
  switch (action.type) {
    // GET (paginated list)
    case azureCostConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
      };
    case azureCostConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case azureCostConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // GET BY ID
    case azureCostConstants.GET_BY_ID_REQUEST:
      return {
        ...state,
        loadingById: true,
      };
    case azureCostConstants.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loadingById: false,
        selectedCost: action.payload,
      };
    case azureCostConstants.GET_BY_ID_FAILURE:
      return {
        ...state,
        loadingById: false,
        errorById: true,
      };

    // CREATE
    case azureCostConstants.CREATE_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        createSuccess: false,
        createError: null,
      };
    case azureCostConstants.CREATE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        createSuccess: true,
      };
    case azureCostConstants.CREATE_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        createError: true,
      };

    // UPDATE
    case azureCostConstants.UPDATE_REQUEST:
      return {
        ...state,
        loadingUpdate: true,
        updateSuccess: false,
        updateError: null,
      };
    case azureCostConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        updateSuccess: true,
      };
    case azureCostConstants.UPDATE_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        updateError: true,
      };

    // DELETE
    case azureCostConstants.DELETE_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        deleteSuccess: false,
        deleteError: null,
      };
    case azureCostConstants.DELETE_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        deleteSuccess: true,
      };
    case azureCostConstants.DELETE_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        deleteError: true,
      };

    // BULK UPSERT
    case azureCostConstants.BULK_UPSERT_REQUEST:
      return {
        ...state,
        loadingBulkUpsert: true,
        bulkUpsertSuccess: false,
        bulkUpsertError: null,
      };
    case azureCostConstants.BULK_UPSERT_SUCCESS:
      return {
        ...state,
        loadingBulkUpsert: false,
        bulkUpsertSuccess: true,
      };
    case azureCostConstants.BULK_UPSERT_FAILURE:
      return {
        ...state,
        loadingBulkUpsert: false,
        bulkUpsertError: true,
      };

    // GET DAILY
    case azureCostConstants.GET_DAILY_REQUEST:
      return {
        ...state,
        loadingDaily: true,
      };
    case azureCostConstants.GET_DAILY_SUCCESS:
      return {
        ...state,
        loadingDaily: false,
        dailyResult: action.payload,
      };
    case azureCostConstants.GET_DAILY_FAILURE:
      return {
        ...state,
        loadingDaily: false,
        dailyError: true,
      };

    // GET MONTHLY
    case azureCostConstants.GET_MONTHLY_REQUEST:
      return {
        ...state,
        loadingMonthly: true,
      };
    case azureCostConstants.GET_MONTHLY_SUCCESS:
      return {
        ...state,
        loadingMonthly: false,
        monthlyResult: action.payload,
      };
    case azureCostConstants.GET_MONTHLY_FAILURE:
      return {
        ...state,
        loadingMonthly: false,
        monthlyError: true,
      };

    // GET QUARTERLY
    case azureCostConstants.GET_QUARTERLY_REQUEST:
      return {
        ...state,
        loadingQuarterly: true,
      };
    case azureCostConstants.GET_QUARTERLY_SUCCESS:
      return {
        ...state,
        loadingQuarterly: false,
        quarterlyResult: action.payload,
      };
    case azureCostConstants.GET_QUARTERLY_FAILURE:
      return {
        ...state,
        loadingQuarterly: false,
        quarterlyError: true,
      };

    // GET SUBSCRIPTIONS
    case azureCostConstants.GET_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        loadingSubscriptions: true,
      };
    case azureCostConstants.GET_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        loadingSubscriptions: false,
        subscriptions: action.payload,
      };
    case azureCostConstants.GET_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        loadingSubscriptions: false,
        subscriptionsError: true,
      };

    // GET CHART DATA (larger datasets for visualization)
    case azureCostConstants.GET_CHART_DATA_REQUEST:
      return {
        ...state,
        loadingChartData: true,
      };
    case azureCostConstants.GET_CHART_DATA_SUCCESS:
      return {
        ...state,
        loadingChartData: false,
        chartData: action.payload,
      };
    case azureCostConstants.GET_CHART_DATA_FAILURE:
      return {
        ...state,
        loadingChartData: false,
        chartDataError: true,
      };

    default:
      return state;
  }
}
